import { sortBy } from 'lodash';
import type { IOption } from '../../../interfaces/option';
import type { ISpecialization } from '../../../interfaces/specialization';

export function convertApiResponseToOptions(specializations: ISpecialization[], language: string) {
    return sortBy(
        specializations.map((item) => {
            let label = '';
            switch (language) {
                case 'en':
                    label = item.descriptionEN;
                    break;
                case 'nl':
                default:
                    label = item.descriptionNL;
                    break;
            }

            return { value: item.id, label } as IOption<string>;
        }),
        (option) => option.label
    );
}
